<ng-container *ngIf="isInitialized">
    <oe-flat-widget [title]="'GENERAL.AUTARCHY' | translate" [icon]="{name: 'oe-grid', color:'environmental'}" button
         class="custom-percentagebar">
        <oe-flat-widget-percentagebar [value]="this.percentageValue">
        </oe-flat-widget-percentagebar>
    </oe-flat-widget>
</ng-container>
